module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAABU0lEQVQ4T+2UoU4DQRRF7932A6jjA/BUIHCAI6EJEvoPnZY6BAlLgqzozvwCCQgEOBxFkFQiQGORCBzZvWQTdjNd2m53NSPf3HfeffNmhliwrLWbkk4BdEh2+v3+0yJtMc5iwFq7AyCF7Wd7JENjzEUlaBiGzVardUDyDMDWn8pVoc65I0mXADYWOansNIqib5LNZa1VhlprVXZWtaGSXkh+Fgq0Aaxl0CiKDgFckbwNgmDU6/Xe5hli5jSO473hcDjxRdbaRwC7GdQ5dy4p9DR3JEfGmGc/L4dKeiD5UaicXqv1JdBMPpE0HgwG92kgh64yqDlOZ9IkvQI48512kySZ+qpGo3ENYHsFp37aVw4leUxyBpokyU0NaO32p3Ecd317QRCkHaWd1YP+Xr8THyqpTXJcG1r6WKq8qLLp57/aP/S99ODJsTEmcs4NJM1MfV7uD1IY9P3S6UQUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/form_Company.png
// module id = RxZh
// module chunks = 0